import axios from "axios";
import { apiBase } from "../Config";

axios.defaults.timeout = 100000;

export default axios.create({
  baseURL: apiBase,
});
